import type { FormLocale } from '@jlg-website/shared';
import type { SlotPeriod } from './type';

export const TOTAL_STEPS = 3;

export const AFTERNOON_STARTS_AT_HOUR = 12;
export const EVENING_STARTS_AT_HOUR = 17;

export const slotPeriods: readonly SlotPeriod[] = ['morning', 'afternoon', 'evening'];

export const weekdayHeadings: Record<FormLocale, string[]> = {
  en: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  es: ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'],
};

export const periodLabels: Record<FormLocale, Record<SlotPeriod, string>> = {
  en: { morning: 'Morning', afternoon: 'Afternoon', evening: 'Evening' },
  es: { morning: 'Mañana', afternoon: 'Tarde', evening: 'Noche' },
};

export const stepTitles: Record<FormLocale, string[]> = {
  en: ['Pick a date', 'Pick a time', 'Confirm your call back'],
  es: ['Elija una fecha', 'Elija un horario', 'Confirme su llamada'],
};
